'use strict';

var index = require('../../../../../index-B_8xeRkv.js');

"use strict";
const pluginVersion = "12.4.1";
const defaultOptions = {
  bucketCount: 30,
  bucketOffset: 0
};
const defaultFieldConfig = {
  fillOpacity: 80,
  gradientMode: index.GraphGradientMode.None,
  lineWidth: 1
};

exports.defaultFieldConfig = defaultFieldConfig;
exports.defaultOptions = defaultOptions;
exports.pluginVersion = pluginVersion;
